module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/cv_3_pc_42c83362c1469a9c2c9dcb7e5267071a.jpg";